<template>
  <div class="input van-cell van-field">
    <input :value="value" @input="input" type="text" class="input">
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        default: ""
      }
    },
    data(){
      return{

      }
    },
    methods:{
      input(){
        this.$emit('input',event.target.value);
      }
    }
  }
</script>
<style>
  .input{
    border: none;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/PageInput.vue